import { useEffect } from "react";

/** Stamps every <td> inside <main> tables with data-label from its <th>, so the
 * mobile CSS (index.css → .hocp-responsive) can render rows as labelled cards. */
function stampTables(root) {
  root.querySelectorAll("table").forEach((table) => {
    if (table.hasAttribute("data-no-cards")) return;
    const ths = table.querySelectorAll(":scope > thead th");
    if (!ths.length) return;
    const labels = Array.from(ths, (th) => (th.getAttribute("data-label") ?? th.textContent ?? "").trim());
    table.classList.add("hocp-responsive");
    table.querySelectorAll(":scope > tbody > tr").forEach((tr) => {
      let col = 0;
      Array.from(tr.children).forEach((td) => {
        if (td.tagName !== "TD" && td.tagName !== "TH") return;
        if (!td.hasAttribute("data-label") || td.dataset.auto === "1") {
          const label = labels[col] ?? "";
          if (td.getAttribute("data-label") !== label) { td.setAttribute("data-label", label); td.dataset.auto = "1"; }
        }
        col += td.colSpan || 1;
      });
    });
  });
}

export function useResponsiveTables() {
  useEffect(() => {
    const root = document.querySelector("main") || document.body;
    let raf = 0;
    const run = () => { raf = 0; stampTables(root); };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(run); };
    schedule();
    const obs = new MutationObserver(schedule);
    obs.observe(root, { childList: true, subtree: true, characterData: true });
    return () => { obs.disconnect(); if (raf) cancelAnimationFrame(raf); };
  }, []);
}
